import { useEffect, useState } from 'react';
import { completeLoginFromCallback } from './cognito';

export default function AuthCallbackPage() {
  const [error, setError] = useState('');

  useEffect(() => {
    const complete = async () => {
      try {
        const returnTo = await completeLoginFromCallback(window.location.search);
        window.location.replace(returnTo);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Login failed');
      }
    };
    complete();
  }, []);

  return (
    <div style={{ padding: '2rem', maxWidth: '520px', margin: '0 auto' }}>
      <h1>Completing sign in...</h1>
      {error ? <p style={{ color: '#c62828' }}>{error}</p> : <p>Please wait.</p>}
    </div>
  );
}

